"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectOrganization = void 0;
const app_module_1 = require("./app.module");
const token_service_1 = require("./token.service");
const _ = require("lodash");
const organization_1 = require("./organization");
const connect_client_1 = require("./connect-client");
const connect_user_1 = require("./connect-user");
const baseURL = "/connect-management/organization";
class ConnectOrganization extends organization_1.Organization {
    constructor(params) {
        super(params);
        this.users = [];
        this.clients = [];
        Object.assign(this, params);
    }
    static autocomplete(name) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
                let response = yield http
                    .get(`${baseURL}/autocomplete?name=${name}`)
                    .toPromise();
                let json = yield response.json();
                let organizations = _.map(json, organization => new ConnectOrganization(organization));
                return organizations;
            }
            catch (err) {
                let error = yield err.json();
                return error;
            }
        });
    }
    static get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
                let response = yield http.get(`${baseURL}/${id}`).toPromise();
                let json = yield response.json();
                let organization = new ConnectOrganization(json);
                organization.users = organization.users.map(user => new connect_user_1.ConnectUser(user));
                organization.clients = organization.clients.map(client => new connect_client_1.ConnectClient(client));
                return organization;
            }
            catch (err) {
                let error = yield err.json();
                return error;
            }
        });
    }
    create() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
                let response = yield http.post(`${baseURL}`, this.params()).toPromise();
                let json = yield response.json();
                let organization = new ConnectOrganization(json);
                return organization;
            }
            catch (err) {
                let json = yield err.json();
                throw json;
            }
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
                let response = yield http
                    .put(`${baseURL}/${this.id}`, this.params())
                    .toPromise();
                let json = yield response.json();
                let organization = new ConnectOrganization(json);
                return organization;
            }
            catch (err) {
                let json = yield err.json();
                throw json;
            }
        });
    }
    params() {
        let params = _.pick(this, ["displayName"]);
        return _(params)
            .omit(_.isUndefined)
            .omit(_.isNull)
            .value();
    }
}
exports.ConnectOrganization = ConnectOrganization;
//# sourceMappingURL=connect-organization.js.map